import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildSeo, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/plans")({
  head: () => {
    const seo = buildSeo({
      title: "باقات تصميم المساحات | BAZZAR 3D",
      description:
        "باقات مرنة للتصميم الداخلي والنماذج ثلاثية الأبعاد من بازار ثري دي — سكني، تجاري، مكاتب، وضيافة. اختر الباقة المناسبة لمشروعك.",
      path: "/plans",
      keywords: "باقات تصميم, أسعار تصميم داخلي, 3D packages, plans, BAZZAR 3D",
    });
    return {
      meta: seo.meta,
      links: seo.links,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "Plans", path: "/plans" },
            ]),
          ),
        },
      ],
    };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/plans")),
});